import { useState, useEffect } from "react";
import api from "../../../api";

const useProceduresPartners = (id, shopperId) => {
  const [proceduresPartners, setProceduresPartners] = useState([]);
  const [loadingPartners, setLoadingPartners] = useState(true);
  const [errorPartners, setErrorPartners] = useState(null);

  useEffect(() => {
    const fetchProcedures = async () => {
      try {
        const response = await api.post("/api/affiliatecompany/list/shopper/procedures/all", {
          shopper_id: shopperId,
          company_id: id
        });
        setProceduresPartners(response.data);
      } catch (err) {
        setErrorPartners(err);
      } finally {
        setLoadingPartners(false);
      }
    };
    fetchProcedures();
  }, [id, shopperId]);  // Adicionando dependências para garantir que o hook seja reexecutado quando id ou shopperId mudarem

  return { proceduresPartners, setProceduresPartners, loadingPartners, errorPartners };
};

export default useProceduresPartners;
